import middlewarePipeline from './middleware/_pipeline';
import progress from './middleware/progress';

const globalMiddleware = [ progress ];

/**
 * Handles the `before()` method in middleware.
 *
 * @returns {void}
 */
export default (to, from, next) => {
	const middleware = globalMiddleware.concat(to.meta.middleware || []);
	const context = {
		to, from, next
	};

	if (middleware.length === 0) {
		return next();
	}

	return middleware[0].before({
		...context,
		next: middlewarePipeline(context, middleware, 1)
	});
};
